export enum TimeFrameSelectBlock {
  Root = 'TimeFrameSelect',
}
